var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blankForm"},[_vm._v("表单开发中。。。")])
}
var staticRenderFns = []

export { render, staticRenderFns }